import { render } from "./Destiny.vue?vue&type=template&id=d5156860"
import script from "./Destiny.vue?vue&type=script&lang=js"
export * from "./Destiny.vue?vue&type=script&lang=js"

import exportComponent from "/builds/arena/frontend/game-maplestory-landing/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__